import { enhancedRequest } from '../utils/request.js'
// 第一轮题目单词生成
const getFirstRoundWords = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/create/question/first',
    method: 'POST',
    data
  })
}
//  单词词意保存第一轮
const saveFirstRoundWordMeaning = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/submit/question/first',
    method: 'POST',
    data
  })
}
// 第二轮题目单词生成
const getSecondRoundWords = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/create/question/second',
    method: 'POST',
    data
  })
}
//  单词词意保存第二轮
const saveSecondRoundWordMeaning = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/submit/question/second',
    method: 'POST',
    data
  })
}
// 第三轮题目单词生成
const getThirdRoundWords = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/create/question/thirdly',
    method: 'POST',
    data
  })
}
//  单词词意保存第三轮
const saveThirdRoundWordMeaning = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/submit/question/thirdly',
    method: 'POST',
    data
  })
}
// 所有报告汇总
const getReportSummary = async (data) => {
  return enhancedRequest({
    url: '/api/v1/quick/quiz/all/quick/quiz/report',
    method: 'get',
    data
  })
}
// 重新检测
const recheckReport = async (data) => {
  console.log('重新检测数据:', data)
  return enhancedRequest({
    url: `/api/v1/quick/quiz/reset?bookId=${data.bookId}&frameworkId=${data.frameworkId}`,
    method: 'put'
  })
}
// 自由学习
const freeLearning = async (data) => {
  return enhancedRequest({
    url: `/api/v1/quick/quiz/close?bookId=${data.bookId}&frameworkId=${data.frameworkId}`,
    method: 'put',
  })
}
export {
  getFirstRoundWords,
  saveFirstRoundWordMeaning,
  getReportSummary,
  recheckReport,
  freeLearning,
  saveSecondRoundWordMeaning,
  getSecondRoundWords,
  getThirdRoundWords,
  saveThirdRoundWordMeaning
}
